module.exports = __webpack_public_path__ + "fonts/fa-solid-900.f960deb9.eot";